export default __webpack_public_path__ + "static/media/finger5.eb7d274a.png";